import React, { useEffect, useState } from "react";

import { format, getYear } from "date-fns";
import ptBR from "date-fns/esm/locale/pt-BR/";

import {
  MdArrowDropUp,
  MdArrowDropDown,
  MdArrowLeft,
} from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
// import * as XLSX from "xlsx";

import {
  Container,
  // Search,
  IconBox,
  Legend,
  ListContent,
  ListItem,
  // Info,
  // Button,
  // Update,
  // Title,
  // Table,
  JustifyList,
  Buttonbox,
  Sliderbox,
  ModalTitle,
  ModalHour,
  Message,
  Hystory,
  ButtonOptions,
} from "./styles";

import ContentBox from "../../components/UI/ContentBox";
import Banner from "../../components/UI/Banner";
// import InputSearch from "../../components/UI/Inputs/InputSearch";
// import CardItem from "../../components/UI/CardItem";
import Footer from "../../components/UI/Footer";
import Menu from "../../components/UI/Menu";
import ReadMoreButton from "../../components/UI/ReadMoreButton"
import FullScreenLoading from "../../components/UI/FullScreenLoading";
import InputSelect from "../../components/UI/Inputs/InputSelect";
import InputText from "../../components/UI/Inputs/InputText";
import Modal from "../../components/UI/Modal";

import textToVectorIsLink from "../../utils/textToVectorIsLink";
import useApi from "../../hooks/useApi";
import { useAuth } from "../../hooks/useAuth";

import { icons } from "../../constants";
import { Item } from "../../components/UI/Menu/styles";

const CoursesRegisterActivities = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams();

  const [courseInfo, setCourseInfo] = useState({});
  const [listInfoSubscribe, setListInfoSubscribe] = useState([]);
  const [listActivities, setListActivities] = useState([]);
  const [listUserActivities, setListUserActivities] = useState([]);
  const [listCompleteActivities, setListCompleteActivities] = useState([]);
  const [listCompleteSubscribe, setListCompleteSubscribe] = useState([]);
  const [listJustify, setListJustify] = useState([]);
  
  const [controlPage, setControlPage] = useState({mode:"activity",view:{activity:"",user:""}});
  const [controlPageView, setControlPageView] = useState("");
  const [controlModal, setControlModal] = useState({open:false,data:{}});
  const [modalError, setModalError] = useState({open:false,message:""});
  const [modalSelectScore, setModalSelectScore] = useState({open:false,activity:"",subscribe:"",userActivity:"",activityWorkload:0,hour:0,update:false,documentName:null,documentUrl:null});
  const [modalMessagePortfolio, setModalMessagePortfolio] = useState({open:false,name:"",title:"",docName:"",docUrl:"",idContentActivity:"",idUserSubscription:""});
  const [messagePortfolio, setMessagePortfolio] = useState("");
  const [modalHistoryPortfolio, setModalHistoryPortfolio] = useState({open:false,userActivities:[]});

  const [batchRegisterActivity, setBatchRegisterActivity] = useState([]);
  const [modalBatch, setModalBatch] = useState({type:"",execute:()=>{}});

  //mode activity or user

  const [loadCourse, loadCourseInfo] = useApi({
    debounceDelay: 1000,
    url: "canalPedagogico/course/activities/coursesByUser",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("course by user", response.data[0]);
        setCourseInfo(response.data[0]);
        if(!(response.data[0].isEditor||response.data[0].isTutor)){
          navigate(`/home2`);
        }
      }
    }
  });

  const [listSubscribe, ListSubscribeInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/subscription/v2",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("listSubscribe", response.data);
        setListInfoSubscribe(response.data);
        loadListActivities({
          params: {
            idContent:id,
          },
        });
      }
    },
    onError: (error)=>{ 
      // document.location.reload(false);
    },
  });

  const [loadListActivities, LoadListActivitiesInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/activities",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("listActivities", response.data);
        setListActivities(response.data);
        loadListUserActivities({
          params: {
            idContent:id,
          },
        });
      }
    },
    onError: (error)=>{ 
      // document.location.reload(false);
    },
  });

  const [loadListUserActivities, LoadListUserActivitiesInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/userActivities/course",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("listUserActivities", response.data);
        setListUserActivities(response.data);
        if(response.data.length === 0){
          adjustVetor();
        }
      }
    },
    onError: (error)=>{ 
      // document.location.reload(false);
    },
  });

  const [postUserActivities, postUserActivitiesInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/userActivities",
    method: "post",
    onCompleted: (response) => {
      if (!response.error) {
        // console.log("atividade criada com sucesso");
        loadListUserActivities({
          params: {
            idContent:id,
          },
        });
        setControlModal({open:false,data:{}});
        setModalSelectScore({open:false,activity:"",subscribe:"",userActivity:"",activityWorkload:0,hour:0,update:false});
      }
    },
    onError: (error)=>{ 
      setModalError({open:true,message:"Erro ao criar registro de atividade"});
      // document.location.reload(false);
    },
  });

  const [putUserActivities, putUserActivitiesInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/userActivities",
    method: "put",
    onCompleted: (response) => {
      if (!response.error) {
        // console.log("atividade atualizada com sucesso");
        loadListUserActivities({
          params: {
            idContent:id,
          },
        });
        setControlModal({open:false,data:{}});
        setModalSelectScore({open:false,activity:"",subscribe:"",userActivity:"",activityWorkload:0,hour:0,update:false});
      }
    },
    onError: (error)=>{ 
      setModalError({open:true,message:"Erro ao atualizar o registro de atividade"});
      // document.location.reload(false);
    },
  });

  const [getListJustify, getListJustifyInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/userActivities/activitiesJustifications",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("listJustify", response.data);
        setListJustify(response.data);
      }
    },
    onError: (error)=>{ 
      // document.location.reload(false);
    },
  });

  const [patchActivity, patchActivityInfo] = useApi({
    debounceDelay: 1000,
    url: "canalPedagogico/course/userActivities/media",
    method: "patch",
    onCompleted: (response) => {
      if (!response.error) {
        setModalMessagePortfolio({open:false,activity:null,userSubscription:null});
        setMessagePortfolio("");
        setModalError({open:true,message:"Mensagem enviada com sucesso"});
        loadListUserActivities({
          params: {
            idContent:id,
          },
        });
      }
    },
    onError: (error)=>{ 
      setModalMessagePortfolio({open:false,activity:null,userSubscription:null});
      setMessagePortfolio("");
      setModalError({open:true,message:"Erro ao enviar mensagem para a atividade"});
      // document.location.reload(false);
    },
  });

  const [postBatchUserActivities, postBatchUserActivitiesInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/userActivities",
    method: "post",
    onCompleted: (response) => {
      if (!response.error) {
        let executar = batchRegisterActivity.filter((item)=>{return item.status==="Processando"})[0];
        setTimeout(()=>{setBatchRegisterActivity([
            ...batchRegisterActivity.filter((item)=>{return item!==executar}),
            {...executar,status:"Pronto"}
          ]);},2000);
      }
    },
    onError: (error)=>{ 
      let executar = batchRegisterActivity.filter((item)=>{return item.status==="Processando"})[0];
      if(executar.retry<3){
        setTimeout(()=>{setBatchRegisterActivity([
          ...batchRegisterActivity.filter((item)=>{return item!==executar}),
          {...executar,status:"Processando",retry:executar.retry+1}
        ]);},2000);
      }
      else{
        setTimeout(()=>{setBatchRegisterActivity([
          ...batchRegisterActivity.filter((item)=>{return item!==executar}),
          {...executar,status:"Erro ao registrar atividade"}
        ]);},2000);
      }
    },
  });

  const postActivity = (data)=>{
    postUserActivities({data});
  };

  // idUserSubscription,
  // idContentActivity, 
  // hoursTaken,
  // idActivitiesJustifications,

  const putActivity = (data)=>{
    putUserActivities({data});
  };

  const postBatchActivity = (data)=>{
    postBatchUserActivities({data});
  };

  // idUserContentActivity, 
  // hoursTaken,
  // idActivitiesJustifications,
  
  useEffect(() => {
    // console.log("Entrou em course Manager");
    loadCourse({
      params:{
        id,
      }
    });
    listSubscribe({
      params: {
        id,
      },
    });
    getListJustify();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    adjustVetor();
    // eslint-disable-next-line
  }, [listUserActivities]);

  useEffect(() => {
    adjustVetor();
    // console.log("mudou modo de pagina",controlPage);
    // eslint-disable-next-line
  }, [controlPage]);

  const adjustVetor = () => {
    let tempAdjust = [];
    if(controlPage.mode==="activity"){
      listActivities.forEach((activity)=>{
        if(activity.activityWorkload>0){
          let tempSubs=[];
          listInfoSubscribe.forEach((subscribe)=>{
            tempSubs.push({
              ...subscribe,
              userActivities:listUserActivities.filter((userActivity)=>{
                return userActivity.idcontent_activity===activity.idContentActivity && 
                userActivity.iduser_subscription===subscribe.idUserSubscription
              })
            });
          });
          tempAdjust.push({...activity,listSubscribe:tempSubs})
        }
      });
      setListCompleteActivities(tempAdjust);
      console.log("listCompleteActivities",tempAdjust);
    }
    if(controlPage.mode==="user"){
      listInfoSubscribe.forEach((subscribe)=>{
        let tempActivities=[];
        listActivities.forEach((activity)=>{
          if(activity.activityWorkload>0){
            tempActivities.push({
              ...activity,
              userActivities:listUserActivities.filter((userActivity)=>{
                return userActivity.idcontent_activity===activity.idContentActivity && 
                userActivity.iduser_subscription===subscribe.idUserSubscription
              })
            });
          }
        });
        tempAdjust.push({...subscribe,listActivities:tempActivities})
      });
      setListCompleteSubscribe(tempAdjust);
      console.log("listCompleteSubscribe",tempAdjust);
    }
  };

  // const handleDownload = () => {
  //   // let maxWidth = [
  //   //   5,
  //   //   10,
  //   //   15,
  //   //   10,
  //   //   10,
  //   //   10
  //   // ]

  //   // listInfoSubscribe.map((sub,index)=>{
  //   //   if(sub.RGF?.length>maxWidth[0])maxWidth[0]=sub.RGF.length;
  //   //   if(sub.Nome?.length>maxWidth[1])maxWidth[1]=sub.Nome.length;
  //   //   if(sub.CPF?.length>maxWidth[2])maxWidth[2]=sub.CPF.length;
  //   //   if(sub.email?.length>maxWidth[3])maxWidth[3]=sub.email.length;
  //   //   if(sub.Escola?.length>maxWidth[4])maxWidth[4]=sub.Escola.length;
  //   //   if(sub.Classe?.length>maxWidth[5])maxWidth[5]=sub.Classe.length;
  //   // });

  //   // // create workbook and worksheet
  //   // const workbook = XLSX.utils.book_new();
  //   // const worksheet = XLSX.utils.table_to_sheet(document.getElementById("tableCourses"));
  //   // maxWidth.forEach((width)=>{worksheet['!cols'].push({ wch: width+2 })});
  //   // console.log(worksheet);

  //   // XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

  //   // XLSX.writeFile(workbook, `${courseInfo?.title}.xlsx`, { compression: true });
  // };

  const getDescriptionJustify = (id) => {
    return listJustify.find((justify)=>{return justify.idactivities_justifications===id})?.description;
  };

  const handleSliderChange = (event) => {
    setModalSelectScore({
      ...modalSelectScore,
      hour:event.target.value
    })
  };

  const getHourActivity = (hour) => {
    return `${Math.trunc(hour)}:${(hour-Math.trunc(hour))*60<10?0:""}${(hour-Math.trunc(hour))*60}`
  }

  const allActivity = (idContentActivity,listSubscribe,activityWorkload)=>{
    let list = [];
    listSubscribe.forEach((subscribe,index)=>{
      if(subscribe.userActivities.filter((item)=>{return item.hours_taken!==null }).length>0){
        list.push({
          update:true,
          retry:0,
          status:"Já Possui registro de Atividade",
          nome:subscribe.name,
          idUserContentActivity:subscribe.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.iduser_content_activity,
          activityScore:activityWorkload,
        })
      }
      else{
        list.push({
          update:false,
          retry:0,
          status:"Aguardando",
          nome:subscribe.name,
          idUserSubscription:subscribe.idUserSubscription,
          idContentActivity:idContentActivity,
          activityScore:activityWorkload,
        })
      }
    });
    setModalBatch({type:"execute",execute:()=>{}});
    setBatchRegisterActivity(list);
  };

  useEffect(() => {
    console.log("batchRegisterActivity",batchRegisterActivity)

    if(batchRegisterActivity.length>0){
      if(batchRegisterActivity.filter((item)=>{return item.status==="Processando"}).length>0){
        let executar = batchRegisterActivity.filter((item)=>{return item.status==="Processando"});
        if(executar.length>0){
          postBatchActivity({
                  activityScore:executar[0]?.activityScore,
                  idUserSubscription:executar[0]?.idUserSubscription,
                  idContentActivity:executar[0]?.idContentActivity,
                  hoursTaken:1,
          })
        }
      }
      else{
        if(batchRegisterActivity.filter((item)=>{return item.status==="Aguardando"}).length>0){
          let processar = batchRegisterActivity.filter((item)=>{return item.status==="Aguardando"})[0];
          setTimeout(()=>{setBatchRegisterActivity([
            ...batchRegisterActivity.filter((item)=>{return item!==processar}),
            {...processar,status:"Processando"}
          ]);},2000);
        }
        else{
          console.log("executou toda a lista");
        }
      }
    }

    // eslint-disable-next-line
  }, [batchRegisterActivity]);

  return (
    <Container>
      {(loadCourseInfo.loading ||
        ListSubscribeInfo.loading ||
        LoadListActivitiesInfo.loading ||
        LoadListUserActivitiesInfo.loading ||
        postUserActivitiesInfo.loading ||
        getListJustifyInfo.loading ||
        putUserActivitiesInfo.loading) && <FullScreenLoading />}
      <Menu />
      <Banner
        // icon={images.iconNovidades}
        url={`/formacoes/editar/${courseInfo?.id}`}
        editorId={"0e3b686a-9b75-4de0-a2b7-28ec578e8119"}
      >
        Registro de atividades do Curso: {courseInfo?.title}
      </Banner>

      {/* <Search>
        <InputSearch
          value={search}
          onChange={handleSearch}
          onClick={handleSearch}
        />
      </Search> */}

      <ContentBox>
        <ListItem border={true} 
                 roundborder={true} 
                 pointer={true} 
                 row={true} 
                 reduct={0} 
                 visible={true} 
                 selected={true} 
                 onClick={()=>{navigate(-1);}}
        >
          <MdArrowLeft fontSize={36}/> Voltar
        </ListItem>
        <ListItem row={true} 
                  visible={true}>
          <ListItem reduct={72}
                    row={true}
                    justify={"space-between"}
                    marTop={0.01}
                    visible={true}>
              <Legend><img src={icons.atividade_feito} alt="Presente"/>Concluído</Legend>
              <Legend><img src={icons.atividade_falta} alt="Falta"/>Não concluído</Legend>
              <Legend><img src={icons.atividade_justificado} alt="Justificada"/>Justificado</Legend>
          </ListItem>
          <ListItem row={true} 
                    marTop={0.01}
                    justify={"flex-end"}
                    reduct={28}
                    visible={true}>
            <InputSelect 
              onChange={(e)=>{setControlPage({...controlPage,mode:e.target.value})}}
              value={controlPage.mode}
              placeholder="Organizar por:">
              <option key={"opt1"} value="activity" defaultValue>Atividade</option>
              <option key={"opt2"} value="user">Inscritos</option>
            </InputSelect>
          </ListItem>
        </ListItem>

        {controlPage.mode === "activity" && <>
          {listCompleteActivities.map((activity)=>(<>
            <ListItem
              border={true}
              roundborder={true} 
              padW={3}
              justify={"flex-start"}
              row={true}
              onClick={()=>{controlPageView===activity.idContentActivity?setControlPageView(""):setControlPageView(activity.idContentActivity)}}
              visible={true}
              pointer={true} 
              selected={controlPageView===activity.idContentActivity}
              key={activity.idContentActivity}>
              {activity.module!==null && <>{activity.module===0?"Módulo único":`Módulo: ${activity.module}` }<br/></>}
              {activity.title} ({'\u0020'}
              {format(new Date(parseInt(activity.activityBegin)), "dd/MM/yyyy", {locale: ptBR,})} -{'\u0020'}
              {format(new Date(parseInt(activity.activityEnd)), "dd/MM/yyyy", {locale: ptBR,})}{'\u0020'})
              {controlPageView===activity.idContentActivity?<MdArrowDropUp fontSize={36}/>:<MdArrowDropDown fontSize={36}/>}
            </ListItem>
            <ListContent
              visible={controlPageView===activity.idContentActivity}
              key={`content-${activity.idContentActivity}`}>
              {user.profiles[0]?.idProfile === "8a833773-7e1d-47d8-9995-e98b3d6fe04a" && <ListItem reduct={5} visible={controlPageView===activity.idContentActivity} row={true} border={true} key={`content-allUser-${activity.idContentActivity}`}>
                <ReadMoreButton
                          text="Todos os cursistas realizaram a atividade"
                          type="button"
                          onClick={()=>{setModalBatch({type:"confirm",execute:()=>{allActivity(activity.idContentActivity,activity?.listSubscribe,activity.activityWorkload);}});}}/>
              </ListItem>}
              {activity?.listSubscribe.map((subscribe)=>(
                <ListItem reduct={5} visible={controlPageView===activity.idContentActivity} row={true} border={true} key={`content-${activity.idContentActivity}-${subscribe.idUserSubscription}`}>
                  <ListItem 
                    padW={1}
                    padV={0}
                    reduct={90}
                    visible={controlPageView===activity.idContentActivity}>
                    {subscribe.userActivities.filter((item)=>{return item.hours_taken!==null }).length>0 && <IconBox>
                      {subscribe.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.hours_taken===0 && <img src={icons.atividade_falta} alt="Falta"/>}
                      {subscribe.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.hours_taken===1 && <img src={icons.atividade_feito} alt="Presente"/>}
                      {subscribe.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.hours_taken===2 && <img src={icons.atividade_justificado} alt="Justificado"/>}
                    </IconBox>}
                  </ListItem>
                  <ListItem 
                    padW={1}
                    padV={0}
                    align={"flex-start"}
                    reduct={35}
                    visible={controlPageView===activity.idContentActivity}>
                      {subscribe.name}
                      <br/>
                      {subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentName && <>
                        {subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.isJustification?
                        <>
                          Justificativa Cursista:<br/>
                          <a href={`${process.env.REACT_APP_CDN_URL}canalPedagogico/course/userActivities/media/${subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentUrl}`} target="_blank" rel="noreferrer">
                            {subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentName}
                          </a><br/>
                          Justificativa enviada em: {format(new Date(subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.created_at), "dd/MM/yyyy - HH:mm", {locale: ptBR,})}
                        </>:
                        <>
                          Arquivo enviado:<br/>
                          <a href={`${process.env.REACT_APP_CDN_URL}canalPedagogico/course/userActivities/media/${subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentUrl}`} target="_blank" rel="noreferrer">
                            {subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentName}
                          </a>
                          {subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.tutor_message && <>
                            <p>Mensagem do tutor:</p> 
                            {textToVectorIsLink(subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.tutor_message).map((desc,index)=>desc.isLink?
                                                          <a href={desc.text} key={index} target="_blank" rel="noreferrer">
                                                            {desc.text}
                                                          </a>:desc.text)}
                          </>}
                        </>}
                      </>}
                      {subscribe?.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.hours_taken===2 && <>Justificativa: {getDescriptionJustify(subscribe?.userActivities[0]?.idactivities_justifications)} </>}
                      {((subscribe?.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.hours_taken===1)&&
                        (getYear(parseInt(activity.activityEnd))>2025)) && <><br/>Horas Realizadas: {getHourActivity(subscribe?.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.activity_score)}</>}
                  </ListItem>
                  <ListItem 
                    reduct={79}
                    visible={controlPageView===activity.idContentActivity}>
                      <ButtonOptions>
                        {(subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentName && subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.isJustification!==true && subscribe.userActivities.filter((item)=>{return item.hours_taken!==null }).length===0) && 
                            <ReadMoreButton
                              text="Enviar Mensagem para o Cursista"
                              type="button"
                              onClick={()=>{setModalMessagePortfolio({
                                open:true,
                                name:subscribe.name,
                                title:activity.title,
                                docName:subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentName,
                                docUrl:subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentUrl,
                                idContentActivity:activity.idContentActivity,
                                idUserSubscription:subscribe.idUserSubscription})}}/>}
                        {(subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentName && subscribe.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.isJustification!==true && subscribe.userActivities.filter((item)=>{return item.hours_taken===null }).length>0) && 
                            <ReadMoreButton
                              text="Histórico de arquivos"
                              type="button"
                              onClick={()=>{setModalHistoryPortfolio({open:true,userActivities:subscribe.userActivities})}}/>}

                        {subscribe.userActivities.filter((item)=>{return item.hours_taken!==null }).length>0?
                        <>
                          <ReadMoreButton
                            text="Realizou Atividade"
                            type="button"
                            onClick={()=>{setModalSelectScore({
                                                open:true,
                                                activity:"",
                                                subscribe:"",
                                                userActivity:subscribe.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.iduser_content_activity,
                                                activityWorkload:activity.activityWorkload,
                                                hour:subscribe.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.activity_score,
                                                update:true})}}/>
                          {subscribe.userActivities.filter((item)=>{return item.hours_taken!==null })[0].hours_taken!==0 && <ReadMoreButton
                            text="Não Realizou Atividade"
                            type="button"
                            onClick={()=>{putActivity({
                                                        activityScore:0,
                                                        idUserContentActivity:subscribe.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.iduser_content_activity,
                                                        hoursTaken:0,
                                            })}}/>}
                          <ReadMoreButton
                            text="Não Realizou Atividade/Justificativa"
                            type="button"
                            onClick={()=>{setControlModal({
                              open:true,
                              data:{
                                activityScore:0,
                                idUserContentActivity:subscribe.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.iduser_content_activity,
                                hoursTaken:2,
                                idActivitiesJustifications:null,
                              }})}}/>
                        </>:
                        <>
                          <ReadMoreButton
                            text="Realizou Atividade"
                            type="button"
                            onClick={()=>{setModalSelectScore({
                                                open:true,
                                                activity:activity.idContentActivity,
                                                subscribe:subscribe.idUserSubscription,
                                                userActivity:"",
                                                activityWorkload:activity.activityWorkload,
                                                hour:activity.activityWorkload,
                                                update:false})}}/>
                          <ReadMoreButton
                            text="Não Realizou Atividade"
                            type="button"
                            onClick={()=>{postActivity({
                                                        activityScore:0,
                                                        idUserSubscription:subscribe.idUserSubscription,
                                                        idContentActivity:activity.idContentActivity,
                                                        hoursTaken:0,
                                    })}}/>
                          <ReadMoreButton
                            text="Não Realizou Atividade/Justificativa"
                            type="button"
                            onClick={()=>{setControlModal({
                              open:true,
                              data:{
                                activityScore:0,
                                idUserSubscription:subscribe.idUserSubscription,
                                idContentActivity:activity.idContentActivity,
                                hoursTaken:2,
                              }
                            })}}/>
                        </>}
                    </ButtonOptions>
                  </ListItem>
                </ListItem>))}
            </ListContent>
          </>))}
        </>}

        {controlPage.mode === "user" && <>
          {listCompleteSubscribe.map((subscribe)=>(<>
            <ListItem
              border={true}
              roundborder={true} 
              padW={3}
              justify={"flex-start"}
              row={true}
              onClick={()=>{controlPageView===subscribe.idUserSubscription?setControlPageView(""):setControlPageView(subscribe.idUserSubscription)}}
              visible={true}
              pointer={true} 
              selected={controlPageView===subscribe.idUserSubscription}
              key={subscribe.idUserSubscription}>
              {subscribe.name}
              {controlPageView===subscribe.idUserSubscription?<MdArrowDropUp fontSize={36}/>:<MdArrowDropDown fontSize={36}/>}
            </ListItem>
            <ListContent
              visible={controlPageView===subscribe.idUserSubscription}
              key={`content-${subscribe.idContentActivity}`}>
              {subscribe?.listActivities.map((activity)=>(
                <ListItem reduct={5} visible={controlPageView===subscribe.idUserSubscription} row={true} border={true} key={`${subscribe.idUserSubscription}-${activity.idContentActivity}`}>
                  <ListItem 
                    padW={0}
                    padV={0}
                    reduct={90}
                    visible={controlPageView===subscribe.idUserSubscription}>
                    
                    {activity.userActivities.filter((item)=>{return item.hours_taken!==null }).length>0 && <IconBox>
                      {activity.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.hours_taken===0 && <img src={icons.atividade_falta} alt="Falta"/>}
                      {activity.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.hours_taken===1 && <img src={icons.atividade_feito} alt="Presença"/>}
                      {activity.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.hours_taken===2 && <><img src={icons.atividade_justificado} alt="Justificado"/></>}
                    </IconBox>}
                  </ListItem>
                  <ListItem 
                    padW={1}
                    padV={0}
                    align={"flex-start"}
                    reduct={35}
                    key={`${subscribe.idUserSubscription}-${activity.idContentActivity}`}
                    visible={controlPageView===subscribe.idUserSubscription}>
                      {activity.title} -
                      {format(new Date(parseInt(activity.activityBegin)), "dd/MM/yyyy", {locale: ptBR,})} - 
                      {format(new Date(parseInt(activity.activityEnd)), "dd/MM/yyyy", {locale: ptBR,})}
                      <br/>
                      {activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentName && <>
                        {activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.isJustification?
                        <>
                          Justificativa Cursista: 
                          <a href={`${process.env.REACT_APP_CDN_URL}canalPedagogico/course/userActivities/media/${activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentUrl}`} target="_blank" rel="noreferrer">
                            {activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentName}
                          </a>
                          <p>Justificativa enviada em: {format(new Date(activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.created_at), "dd/MM/yyyy - HH:mm", {locale: ptBR,})}</p>
                        </>:
                        <>
                          Arquivo enviado:<br/>
                          <a href={`${process.env.REACT_APP_CDN_URL}canalPedagogico/course/userActivities/media/${activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentUrl}`} target="_blank" rel="noreferrer">
                            {activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentName}
                          </a>
                          {activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.tutor_message && <>
                            Mensagem do tutor: {activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.tutor_message}
                          </>}
                        </>}
                      </>}
                      {activity?.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.hours_taken===2 && <>Justificativa: {getDescriptionJustify(activity?.userActivities[0]?.idactivities_justifications)} </>}
                      {((activity?.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.hours_taken===1)&&
                        (getYear(parseInt(activity.activityEnd))>2025)) && <><br/>Horas Realizadas: {getHourActivity(activity?.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.activity_score)}</>}
                  </ListItem>
                  <ListItem 
                    reduct={79}
                    visible={controlPageView===subscribe.idUserSubscription}>
                      <ButtonOptions>
                        {(activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentName && activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.isJustification!==true && activity.userActivities.filter((item)=>{return item.hours_taken!==null }).length===0) && 
                            <ReadMoreButton
                              text="Enviar Mensagem para o Cursista"
                              type="button"
                              onClick={()=>{setModalMessagePortfolio({
                                open:true,
                                name:subscribe.name,
                                title:activity.title,
                                docName:activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentName,
                                docUrl:activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentUrl,
                                idContentActivity:activity.idContentActivity,
                                idUserSubscription:subscribe.idUserSubscription})}}/>}

                        {(activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.documentName && activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.isJustification!==true && activity.userActivities.filter((item)=>{return item.hours_taken===null }).length>0) && 
                            <ReadMoreButton
                              text="Histórico de arquivos"
                              type="button"
                              onClick={()=>{setModalHistoryPortfolio({open:true,userActivities:activity.userActivities});console.log("activity.userActivities",activity.userActivities)}}/>}

                        {activity.userActivities.filter((item)=>{return item.hours_taken!==null }).length>0?
                        <>
                          <ReadMoreButton
                            text="Realizou Atividade"
                            type="button"
                            onClick={()=>{setModalSelectScore({
                                                open:true,
                                                activity:"",
                                                subscribe:"",
                                                userActivity:activity.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.iduser_content_activity,
                                                activityWorkload:activity.activityWorkload,
                                                hour:activity.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.activity_score,
                                                update:true})}}/>
                          {activity.userActivities[0].hours_taken!==0 && <ReadMoreButton
                            text="Não Realizou Atividade"
                            type="button"
                            onClick={()=>{putActivity({
                                                        activityScore:0,
                                                        idUserContentActivity:activity.userActivities.filter((item)=>{return item.hours_taken===null })[0]?.iduser_content_activity,
                                                        hoursTaken:0,
                                                        idActivitiesJustifications:null,
                                            })}}/>}
                          <ReadMoreButton
                            text="Não Realizou Atividade/Justificativa"
                            type="button"
                            onClick={()=>{setControlModal({
                              open:true,
                              data:{
                                activityScore:0,
                                idUserContentActivity:activity.userActivities.filter((item)=>{return item.hours_taken!==null })[0]?.iduser_content_activity,
                                hoursTaken:2,
                                idActivitiesJustifications:null,
                              }})}}/>
                        </>:
                        <>
                          <ReadMoreButton
                            text="Realizou Atividade"
                            type="button"
                            onClick={()=>{setModalSelectScore({
                                                open:true,
                                                activity:activity.idContentActivity,
                                                subscribe:subscribe.idUserSubscription,
                                                userActivity:"",
                                                activityWorkload:activity.activityWorkload,
                                                hour:activity.activityWorkload,
                                                update:false})}}/>
                          <ReadMoreButton
                            text="Não Realizou Atividade"
                            type="button"
                            onClick={()=>{postActivity({
                                                        activityScore:0,
                                                        idUserSubscription:subscribe.idUserSubscription,
                                                        idContentActivity:activity.idContentActivity,
                                                        hoursTaken:0,
                                    })}}/>
                          <ReadMoreButton
                            text="Não Realizou Atividade/Justificativa"
                            type="button"
                            onClick={()=>{setControlModal({
                              open:true,
                              data:{
                                activityScore:0,
                                idUserSubscription:subscribe.idUserSubscription,
                                idContentActivity:activity.idContentActivity,
                                hoursTaken:2,
                              }
                            })}}/>
                        </>}
                      </ButtonOptions>
                  </ListItem>
                </ListItem>))}
            </ListContent>
          </>))}
        </>}

        <Modal open={controlModal.open} buttonClose={false}>
          <JustifyList>
            {listJustify.map((justify)=>(
              <ListItem 
                key={justify.idactivities_justifications}
                pointer={true}
                roundborder={true} 
                visible={true}
                className={justify.label}
                onClick={()=>{
                  controlModal.data.idUserContentActivity?
                    putActivity({...controlModal.data,idActivitiesJustifications:justify.idactivities_justifications}):
                    postActivity({...controlModal.data,idActivitiesJustifications:justify.idactivities_justifications})}}>
                {`${justify.label} - ${justify.description}`}
              </ListItem>
            ))}
          </JustifyList>
          <ReadMoreButton
            text="Cancelar"
            type="button"
            onClick={()=>{setControlModal({open:false,data:{}});}}
            disabled={false}
          />
        </Modal>

        <Modal open={modalError.open} buttonClose={false}>
          <div>{modalError.message}</div>
          <ReadMoreButton
            text="Ok"
            type="button"
            onClick={()=>{setModalError({open:false,message:""});}}
            disabled={false}
          />
        </Modal>

        <Modal open={modalSelectScore.open} buttonClose={false}>
          <ModalTitle>Horas realizadas pelo cursista:</ModalTitle>
          <ModalHour>{getHourActivity(modalSelectScore.hour)}</ModalHour>
          <Sliderbox>
            <input type="range" max={modalSelectScore.activityWorkload} min={0} step={0.25} id="myRange" onChange={handleSliderChange} value={modalSelectScore.hour}/><br/>
          </Sliderbox>
          <Buttonbox>
            <ReadMoreButton
              text="cancelar"
              type="button"
              onClick={()=>{setModalSelectScore({open:false,activity:"",subscribe:"",userActivity:"",activityWorkload:0,hour:0,update:false,documentName:null,documentUrl:null})}}
              disabled={false}
            />
            <ReadMoreButton
              text="Ok"
              type="button"
              onClick={()=>{
                if(modalSelectScore.update){
                  putActivity({
                              activityScore:modalSelectScore.hour,
                              idUserContentActivity:modalSelectScore.userActivity,
                              hoursTaken:1,
                              idActivitiesJustifications:null,
                  })
                }else{
                  postActivity({
                              activityScore:modalSelectScore.hour,
                              idUserSubscription:modalSelectScore.subscribe,
                              idContentActivity:modalSelectScore.activity,
                              hoursTaken:1,
                  })
                }
              }}
              disabled={false}
            />
          </Buttonbox>
        </Modal>
        <Modal open={modalMessagePortfolio.open} buttonClose={false}>
          <p>Atividade: {modalMessagePortfolio.title}</p>
          <p>Inscrito: {modalMessagePortfolio.name}</p>
          <p>Arquivo enviado: <a href={`${process.env.REACT_APP_CDN_URL}canalPedagogico/course/userActivities/media/${modalMessagePortfolio.docUrl}`
          } target="_blank" rel="noreferrer">
            {modalMessagePortfolio.docName}
          </a></p>
          <Message>
            <InputText
                placeholder="Mensagem"
                columns={90}
                onChange={(value)=>{setMessagePortfolio(value.target.value)}}
                value={messagePortfolio}
              />
          </Message>

          <Buttonbox>
            <ReadMoreButton
              text="cancelar"
              type="button"
              onClick={()=>{setModalMessagePortfolio({open:false,name:"",title:"",docName:"",docUrl:"",idContentActivity:"",idUserSubscription:""});setMessagePortfolio("");}}
              disabled={false}
            />
            <ReadMoreButton
              text="Ok"
              type="button"
              onClick={()=>{
                patchActivity({data:{
                  idContentActivity:modalMessagePortfolio.idContentActivity,
                  idUserSubscription:modalMessagePortfolio.idUserSubscription,
                  tutorMessage:messagePortfolio
                }});
              }}
              disabled={false}
            />
          </Buttonbox>
        </Modal>

        <Modal open={modalHistoryPortfolio.open} buttonClose={false}>
          {modalHistoryPortfolio.userActivities.filter((item)=>{return item.hours_taken===null }).reverse().map((item)=><Hystory>
            <p>{format(new Date(item.created_at), 'dd/MM/yyyy - HH:mm')}</p> 
            <p>
              <a href={`${process.env.REACT_APP_CDN_URL}canalPedagogico/course/userActivities/media/${item.documentUrl}`} target="_blank" rel="noreferrer">
                {item.documentName}
              </a>
            </p>
            {item.tutor_message && <p>Mensagem do tutor: {item.tutor_message}</p>}
            <br/>
          </Hystory>)}
          <Buttonbox>
            <ReadMoreButton
              text="close"
              type="button"
              onClick={()=>{setModalHistoryPortfolio({open:false,userActivities:[]})}}
              disabled={false}
            />
          </Buttonbox>
        </Modal>

        <Modal open={modalBatch.type!==""} buttonClose={false}>

          {modalBatch.type === "confirm" && <>
            criar registros de atividade para todos os cursistas que não possuem registro de atividade com a hora maxima de realização da atividade?
            <Buttonbox>
            <ReadMoreButton 
              text="Confirmar"
              type="button"
              onClick={()=>{modalBatch.execute()}}
              disabled={false}
            />
            <ReadMoreButton 
              text="Cancelar"
              type="button"
              onClick={()=>{setModalBatch({type:"",execute:()=>{}});}}
              disabled={false}
            />
            </Buttonbox>
            </>}

          {modalBatch.type === "execute" && <>
              {batchRegisterActivity.sort(
                (a, b)=>{
                  let x = a.nome.toLowerCase();
                  let y = b.nome.toLowerCase();
                  if (x < y) {return -1;}
                  if (x > y) {return 1;}
                  return 0;
                }).map((item)=>
                  <p>{item.nome} - {item.status}</p>
              )}
              <ReadMoreButton 
                text="Fechar"
                type="button"
                onClick={()=>{
                  setModalBatch({type:"",execute:()=>{}});
                  loadListUserActivities({params: {idContent:id,}});
                }}
                disabled={batchRegisterActivity.filter((item)=>{return (item.status==="Aguardando"||item.status==="Processando")}).length>0}
              />
            </>}
        </Modal>

      </ContentBox>

      <Footer />
    </Container>
  );
};

export default CoursesRegisterActivities;
